import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: absolute;
  top: -15px;
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.9);
  justify-content: space-between;
  width: 95%;
  & i {
    padding-right: 5px;
  }
`;

export const Timestamp = styled.div``;

export const UserInfo = styled.div`
  width: 33%;
`;

export const ItemNumber = styled.div``;

export const ReplyTo = styled.a`
  text-decoration: underline;
  color: #0095E8;
  &:hover {
    cursor: pointer;
  }
`;
